export default "/images/logo-13.png?cfe849f07d87f6f84cc0af1f3075d515";